(function () {
  if (window.colourLandPreviewDimensionsReady) return;
  window.colourLandPreviewDimensionsReady = true;
  var selector = 'img[data-colourland-preview-dimensions]';

  function refresh(image, loaded) {
    var source = image.getAttribute('src');
    var width = 0;
    var height = 0;
    if (source && source.trim() && image.complete && image.naturalWidth > 0 && image.naturalHeight > 0) {
      var current = image.currentSrc;
      if (loaded || !current || current === image.src) {
        width = image.naturalWidth;
        height = image.naturalHeight;
      }
    }
    image.setAttribute('width', String(width));
    image.setAttribute('height', String(height));
  }

  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(selector)) refresh(node, false);
    node.querySelectorAll(selector).forEach(function (image) { refresh(image, false); });
  }

  document.addEventListener('load', function (event) {
    var image = event.target;
    if (image && image.nodeType === 1 && image.matches(selector)) refresh(image, true);
  }, true);
  scan(document.documentElement);
  var observer = new MutationObserver(function (changes) {
    changes.forEach(function (change) {
      if (change.type === 'attributes') {
        if (change.target.matches(selector)) refresh(change.target, false);
      } else {
        change.addedNodes.forEach(scan);
      }
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
})();
